import React, { Component } from 'react';
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import { toast } from 'react-toastify';
import MainSettingContext from './MainSettingContext';
import { t } from './i18n';
class App extends Component {
    static contextType = MainSettingContext;

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: true,
            prolistx: [],
            username: props.username || null,
            userid: props.userid || null,
            showmodal: false,
            phoneNumber: "",
            balance: props.balance || 0,
            mainacc: null,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            loginstate: props.loginstate || false,
            fullname: null,
            lname: null,
            alert: null,
            depositstate: 0,
            depositamount: 0,
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            affpercent: 0,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            tblnextrank: [],
            tblrankall: [],
            tblprofile: props.tblprofile || [],
            prodetail: [],
            linkaff: props.linkaff || "",
            picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
            proderedeem: [],
            buttoncliam: false,
            limit: props.limit || null,
            rankpic: props.rankpic || null,
            rankname: props.rankname || null,
            rankob: props.rankob || null,
            termAndCondition: false,
            errorstatus: false,
        }
    }
    get lang() {
        return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    }

    confirmdeposit = async (e, num) => {

        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;

        await instance.post("/api/v1/getredeempromotion", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    proderedeem: res.data.message.tblpromotionredeems,
                });

            }
        }).catch(async (err) => {
        });

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                if (num === 0) {
                    if (token != null) {
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.picture
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("success", t(this.lang, 'deposit_limit_prefix') + ' ' + this.state.limit.min + ' ' + t(this.lang, 'baht') + ' ' + t(this.lang, 'deposit_max_label') + ' ' + this.state.limit.max);
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }
        else {
            this.setState({
                depositstate: 0
            });
        }

    }
    async componentDidMount() {
        this.promotionlist();

        const username = this.props.username || (() => {
            const token = localStorage.getItem('auth_token');
            if (token) { try { return jwt_decode(token).message.playerid; } catch(e) {} }
            return null;
        })();

        if (username) {
            this.setState({ username });
            const token = localStorage.getItem('auth_token');
            await instance.post("/api/v1/getredeempromotion", {
                userid: username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    this.setState({ proderedeem: res.data.message.tblpromotionredeems });
                }
            }).catch(async (err) => {
                console.error("Error fetching redeem promotion data:", err);
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loginstate !== this.props.loginstate ||
            prevProps.balance !== this.props.balance ||
            prevProps.point !== this.props.point) {
            if (this.props.loginstate && this.props.username) {
                this.setState({
                    loginstate: this.props.loginstate,
                    username: this.props.username,
                    userid: this.props.userid,
                    balance: this.props.balance,
                    point: this.props.point,
                    tblprofile: this.props.tblprofile,
                    rankpic: this.props.rankpic,
                    rankname: this.props.rankname,
                    rankob: this.props.rankob,
                    rankpoint: this.props.rankpoint,
                    linkaff: this.props.linkaff,
                });
            }
        }
    }
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'session_expired'),
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ok')
                })
                window.location.href = '/';
            }
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {

                if (res.data.status === 200) {
                    this.setState({
                        showmodal: false,
                    })

                }
                else if (res.data.status === 201) {
                    await this.notify("success", t(this.lang, 'promo_not_eligible'));
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 204) {
                    e.preventDefault();

                    await this.notify("success", t(this.lang, 'promo_daily_used_up'));
                    return false;
                }
                else if (res.data.status === 202) {
                    e.preventDefault();

                    await this.notify("success", t(this.lang, 'promo_already_used'));
                    return false;
                }

                await instance.post("/api/v1/getredeempromotion", {
                    userid: Username,
                    System: Systems,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        this.setState({
                            proderedeem: res.data.message.tblpromotionredeems,
                        });

                    }
                }).catch(async (err) => {
                    console.error("Error fetching redeem promotion data:", err);
                });
            }).catch(async (err) => {
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("success", t(this.lang, 'session_expired'));
                    window.location.href = '/';
                }
            });
        }
    }

    checkpro = async (e, proid) => {
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }

            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", t(this.lang, 'promo_pending_deposit'));
                return false;
            }

        }).catch(async (err) => {
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("success", t(this.lang, 'session_expired'));
                window.location.href = '/';
            }
        });
    }
    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await Swal.fire({
                        title: 'Success!',
                        text: t(this.lang, 'coupon_success_title'),
                        icon: 'success',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    await this.notify("success", t(this.lang, 'coupon_success_title'));
                }
                else {
                    await this.notify("error", t(this.lang, 'invalid_coupon'));
                }
            });
        }
        else {
            await this.notify("error", t(this.lang, 'not_logged_in'));
        }

    }
    notify = async (mode, msg) => {
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    waitnotify = async () => {
    }
    onChangex = event => {

        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "phoneNumber") {
                document.getElementById("phoneNumberforget").style = "";
                document.getElementById("checkotpforgetphone").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };

    cancelPromotion = async (e) => {
        try {
            e.preventDefault();

            const currentPromotion =
                this.state.proderedeem &&
                    this.state.proderedeem.length > 0
                    ? this.state.proderedeem[0]
                    : null;

            if (!currentPromotion) {
                await Swal.fire({
                    icon: 'warning',
                    title: t(this.lang, 'no_current_promo'),
                    text: t(this.lang, 'no_current_promo'),
                    confirmButtonText: t(this.lang, 'ok')
                });

                return;
            }

            const confirm = await Swal.fire({
                title: t(this.lang, 'cancel_promo_title'),
                text: t(this.lang, 'cancel_promo_text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t(this.lang, 'confirm'),
                cancelButtonText: t(this.lang, 'cancel'),
                reverseButtons: true
            });

            if (!confirm.isConfirmed) {
                return;
            }

            const token = localStorage.getItem('auth_token');

            if (!token) {
                await Swal.fire({
                    icon: 'error',
                    title: t(this.lang, 'session_expired'),
                    text: t(this.lang, 'session_expired'),
                    confirmButtonText: t(this.lang, 'ok')
                });

                return;
            }

            const decoded = jwt_decode(token);

            const Username = decoded.message.playerid;

            this.setState({
                loadingcancelpromotion: true
            });

            const res = await instance.post(
                '/api/v1/usercancelpromotion',
                {
                    User_id: Username,
                    System: Systems,
                    no:
                        currentPromotion.redeemno ||
                        currentPromotion.no
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.data.status === 200) {
                this.setState({
                    proderedeem: [],
                    loadingcancelpromotion: false
                });

                await Swal.fire({
                    icon: 'success',
                    title: t(this.lang, 'status_approve'),
                    text: t(this.lang, 'cancel_promo_success'),
                    confirmButtonText: t(this.lang, 'ok')
                });

                if (this.getredeempromotion) {
                    this.getredeempromotion();
                }

                return;
            }

            this.setState({
                loadingcancelpromotion: false
            });

            await Swal.fire({
                icon: 'error',
                title: t(this.lang, 'failed_title'),
                text: res.data.message || t(this.lang, 'cancel_promo_failed'),
                confirmButtonText: t(this.lang, 'ok')
            });
        } catch (error) {
            this.setState({
                loadingcancelpromotion: false
            });

            await Swal.fire({
                icon: 'error',
                title: t(this.lang, 'error'),
                text: error?.message || t(this.lang, 'cancel_promo_failed'),
                confirmButtonText: t(this.lang, 'ok')
            });
        }
    };
    render() {
        const lang = this.props.language || this.context?.language || 'th';
        const { prodetail, picnonpro, username, prolistx } = this.state
        return (
            <>
                <div className="padding-router-view">
                    <div className="container p-0 x-margin-top-v3">
                        <div className="row m-0 border-shadow-title">
                            <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                    <div>
                                        <div className="text-title text-white-v1 text-center">
                                            <div className="d-flex justify-content-between">
                                                <div className="text-white-v1-deposit">
                                                    <a role="button" href='/'>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={25}
                                                            height={25}
                                                            fill="currentColor"
                                                            className="bi bi-arrow-left-circle text-white"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                            />
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div className="text-white-v1-deposit">
                                                    <h5>{t(lang, 'promotion_title')}</h5>
                                                </div>
                                                <div>{/**/}</div>
                                            </div>
                                            <hr className="mt-0" />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    data-v-ab1d19ba=""
                                    className="auction animated animatedFadeInUp fadeInUp"
                                    role="button"
                                >
                                    <div
                                        data-v-ab1d19ba=""
                                        className="auction__body-menu auction__body--border-radius"
                                    >
                                        <div data-v-ab1d19ba="" className="tab text-white-v1">
                                            <div className="mb-1">
                                                <label htmlFor="price" className="mt-1 mb-1 text-left">
                                                    Code Coupon
                                                </label>
                                                <div className="-x-input-icon flex-column">
                                                    <div className="input-group mb-1">
                                                        <input
                                                            type="text"
                                                            onChange={this.onChangex}
                                                            id="couponkey"
                                                            name="couponkey"
                                                            className="bg-border-input form-control form-control-form form-not-input-login-register"
                                                            placeholder=""
                                                            aria-label={0}
                                                            aria-describedby="basic-addon1"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-2 mb-2">
                                                {/**/}
                                                <div>
                                                    <div>
                                                        <button
                                                            onClick={(e) => {
                                                                this.couponredeem(e)
                                                            }}
                                                            type="submit"
                                                            className="btn -submit js-submit-accept-term v-login mt-0 w-100 p-2 mb-4"
                                                        >
                                                            {t(lang, 'confirm')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="text-white-v1-deposit text-center mb-4">
                                                    <div className="box-content p-0">
                                                        <div className="sub-content p-3">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="promotion-active-box">
                                                                    {this.state.proderedeem &&
                                                                        this.state.proderedeem.length > 0 ? (
                                                                        <div className="promotion-active-content">
                                                                            <div className="promotion-active-left">
                                                                                <div className="promotion-active-icon">
                                                                                    🎁
                                                                                </div>

                                                                                <div className="promotion-active-detail">
                                                                                    <div className="promotion-active-title">
                                                                                        {t(lang, 'in_use_promo')}
                                                                                    </div>

                                                                                    <div className="promotion-active-name">
                                                                                        {
                                                                                            this.state.proderedeem[0]
                                                                                                ?.proname ||
                                                                                            this.state.proderedeem[0]
                                                                                                ?.promotionname ||
                                                                                            t(lang, 'current_promo_label')
                                                                                        }
                                                                                    </div>

                                                                                    <div className="promotion-active-desc">
                                                                                        {t(lang, 'promo_auto_on_deposit')}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <button
                                                                                className="promotion-cancel-btn"
                                                                                disabled={
                                                                                    this.state.loadingcancelpromotion
                                                                                }
                                                                                onClick={this.cancelPromotion}
                                                                            >
                                                                                {this.state
                                                                                    .loadingcancelpromotion ? (
                                                                                    <>
                                                                                        <i className="fa fa-spinner fa-spin" />
                                                                                        &nbsp; {t(lang, 'cancelling_label')}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        ✕ {t(lang, 'cancel_promo')}
                                                                                    </>
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="promotion-empty-box">
                                                                            <div className="promotion-empty-icon">
                                                                                🎉
                                                                            </div>

                                                                            <div>
                                                                                <div className="promotion-empty-title">
                                                                                    {t(lang, 'no_promo_selected')}
                                                                                </div>

                                                                                <div className="promotion-empty-desc">
                                                                                    {t(lang, 'select_promo_below')}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-2 mb-4">
                                                <label htmlFor="price" className="mb-1 text-left">
                                                    {t(lang, 'promotion_title')}
                                                </label>

                                                <div className="p-1">
                                                    <div className="row">
                                                        {prolistx.map(prolists => (
                                                            <div key={prolists.no} className="text-center mb-4 col-12 col-lg-4">
                                                                <a
                                                                    href="#0"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={(e) => this.checkpro(e, prolists.no)}
                                                                >
                                                                    <div
                                                                        className="p-1 bg-mission-button example"
                                                                    >
                                                                        <img
                                                                            className="w-100"
                                                                            data-action="zoom"
                                                                            src={prolists.linkpicture}
                                                                            alt={prolists.linkpicture}
                                                                            style={{ borderRadius: 13 }}
                                                                        />
                                                                        <div className="text position-auto-text">
                                                                            {prolists.proname}
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div
                    className={(this.state.showmodal) ? "modal fade show" : ""}
                    id="show_img"
                    aria-labelledby="show_imgLabel"
                    tabIndex={-1}
                    aria-modal="true"
                    role="dialog"
                    style={{ display: (this.state.showmodal) ? "block" : "none" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content bg-popup-modal p-2">
                            <div className="modal-header pt-0 pb-0">
                                <a
                                    href="#0"
                                    onClick={(e) =>
                                        this.setState({
                                            showmodal: false,
                                        })
                                    }
                                >
                                    <small
                                        className="text-white-v1"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={30}
                                            height={30}
                                            fill="currentColor"
                                            className="bi bi-x-circle"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </small>
                                </a>
                            </div>
                            <div className="modal-body">

                                {(prodetail.length === 0) ?
                                    <div>
                                        <img
                                            style={{ display: (prodetail.linkpicture !== null) ? "" : "none" }}
                                            src={picnonpro}
                                            alt="img_show_popup"
                                            className="img_show_popup"
                                        />
                                        <div className="box-content-pro mt-2 pt-2 pb-2">
                                            <div className="sub-content-pr0 p-2">{t(lang, 'terms_conditions')}</div>
                                        </div>
                                        <div className="text-left"> <pre
                                            className="text-color-promotion"
                                            style={{ whiteSpace: "pre-line" }}
                                        >{t(lang, 'promo_not_active')}
                                        </pre>
                                        </div> </div> : <div>
                                        <img

                                            style={{ display: (prodetail.linkpicture !== null) ? "" : "none" }}
                                            src={prodetail.linkpicture}
                                            alt="img_show_popup"
                                            className="w-100"
                                        />
                                        <div className="box-content-pro mt-2 pt-2 pb-2">
                                            <div className="sub-content-pr0 p-2">{t(lang, 'terms_conditions')}</div>
                                        </div>
                                        <div className="text-left" style={{ color: "white" }}>
                                            <section
                                                dangerouslySetInnerHTML={{ __html: prodetail.detail }}
                                            />
                                        </div>
                                        <div className="card-footer" style={{ display: (prodetail.prolist == 5) ? "none" : "" }}>
                                            <button
                                                className="btn "
                                                style={{ fontWeight: "300", background: "radial-gradient(100% 100% at 50% 0, #f9cf95 0, #c69a5d 100%)", display: (username !== null) ? "" : "none" }}
                                                onClick={(e) => this.redeempro(e, prodetail.no)}
                                            >
                                                <span>{t(lang, 'apply_promo')}</span>
                                            </button>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>

            </>

        );
    }
}

export default App;
